<script>
/**
 * Imports
 */
import SignupFormGroup from "./../form/SignupFormGroup.vue";

/**
 * Component: Sections: Base
 *
 * The component used for displaying the Base section
 * on signup form. The fields and the data is configured
 * from wp-admin and Sections CPT.
 *
 * @author PH
 */
export default {
  data() {
    return {
      l18n: {},
      settings: {}
    };
  },

  created: function() {
    this.l18n = this.getData("l18n");
    this.settings = this.getData("settings");
  },

  computed: {
    valid: {
      get() {
        return this.$store.getters.getSectionData("basic", "valid");
      },
      set(value) {
        this.$store.commit("updateSection", {
          section: "basic",
          values: {
            valid: value
          }
        });
      }
    },

    active() {
      return this.$store.getters.getSectionData("basic", "active");
    },

    next() {
      return this.$store.getters.getSectionData("basic", "next");
    },

    submitLabel() {
      if (this.settings.submitLabel) {
        return this.settings.submitLabel;
      }
      return this.l18n.submit.continue;
    }
  },

  methods: {
    /**
     * Submit: Form
     *
     * @author PH
     * @return void
     */
    submitForm: function(e) {
      e.preventDefault();

      let valid = true;
      let section = this.$store.getters.getSection("basic");

      if (section && section.fields) {
        section.fields.forEach(field => {
          if (!field.valid) {
            this.$store.commit("updateInput", {
              id: field.id,
              section: "basic",
              values: {
                valid: false
              }
            });

            valid = false;
          }
        });
      }

      this.valid = valid;

      if (this.valid) {
        this.$store.commit("changeSection", {
          id: this.next
        });
      }
    },

    /**
     * Get: Data
     *
     * @author PH
     * @return string|bool
     */
    getData: function(property) {
      if (property) {
        return this.$store.getters.getSectionData("basic", property);
      }
      return false;
    },

    /**
     * Get: Group
     *
     * Function filters all the fields and gets
     * fields which are needed for the specific group.
     *
     * @author PH
     * @return array
     */
    getFields(group) {
      return this.getData("fields").filter(field => {
        return field.group === group;
      });
    }
  },

  components: { SignupFormGroup }
};
</script>

<template>
  <div
    class="signup-section signup-section-basic"
    :class="{ valid: valid === true, invalid: valid === false }"
    v-if="active"
  >
    <form action method="POST" @submit="submitForm">
      <div class="signup-section__header">
        <h2>{{getData('header')}}</h2>
        <p v-if="getData('introduction')">{{ getData('introduction') }}</p>
      </div>

      <div class="signup-section__content">
        <signup-form-group
          v-for="group in getData('groups')"
          v-bind:key="group.id"
          v-bind:title="group.title"
          v-bind:fields="getFields(group.id)"
          section="basic"
        ></signup-form-group>
      </div>

      <div class="signup-section__footer">
        <div class="signup-section__notifications" v-if="valid === false">
          <p>{{l18n.submit.error}}</p>
        </div>
        <div class="signup-section__submit">
          <button type="submit">{{submitLabel}}</button>
        </div>
      </div>
    </form>
  </div>
</template>

